var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgPassion(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 411 411",
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    style: {
      fillRule: "evenodd",
      clipRule: "evenodd",
      strokeLinejoin: "round",
      strokeMiterlimit: 2
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "none"
    },
    d: "M.985.095h410v410h-410z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.318 123.318h-35.556V87.762l42.667-42.666v35.555h35.555l-42.666 42.667ZM309.095 233.54c0 17.593-3.456 34.361-9.713 49.707a131.178 131.178 0 0 1-15.147 27.278c-23.893 33.067-62.777 54.571-106.695 54.571-72.661 0-131.556-58.895-131.556-131.556s58.895-131.555 131.556-131.555 131.555 58.894 131.555 131.555Z",
    style: {
      fill: "#ffd615",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.54,
    cy: 233.54,
    r: 81.778,
    style: {
      fill: "#f3f3f1"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 177.54,
    cy: 233.54,
    r: 32,
    style: {
      fill: "#ffd615"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m177.54 233.54 106.667-106.667L177.54 233.54Z",
    style: {
      fill: "#ffd615",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M74.429 233.54c0-67.854 51.37-123.662 117.333-130.759-4.679-.498-9.415-.796-14.222-.796-72.661 0-131.556 58.894-131.556 131.555s58.895 131.556 131.556 131.556c4.807 0 9.543-.299 14.222-.797-65.963-7.097-117.333-62.905-117.333-130.759Z",
    style: {
      fill: "#dcb400",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.207 233.54c0-40.306 29.184-73.714 67.555-80.455-4.622-.811-9.358-1.323-14.222-1.323-45.17 0-81.778 36.608-81.778 81.778 0 45.17 36.608 81.778 81.778 81.778 4.864 0 9.6-.498 14.222-1.323-38.371-6.741-67.555-40.149-67.555-80.455Z",
    style: {
      fill: "#d5dbe1",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M173.984 233.54c0-12.53 7.282-23.282 17.778-28.53-4.295-2.147-9.088-3.47-14.222-3.47-17.678 0-32 14.322-32 32s14.322 32 32 32c5.134 0 9.927-1.323 14.222-3.47-10.496-5.248-17.778-16-17.778-28.53ZM330.429 45.096l-42.667 42.666v35.556l42.667-42.667V45.096Z",
    style: {
      fill: "#dcb400",
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.318 133.985h-35.556c-5.888 0-10.667-4.779-10.667-10.667V87.762c0-2.83 1.124-5.546 3.129-7.537l42.667-42.667a10.659 10.659 0 0 1 18.204 7.538v24.889h24.889c4.31 0 8.207 2.602 9.856 6.584 1.65 3.983.74 8.576-2.318 11.62l-42.667 42.667a10.621 10.621 0 0 1-7.537 3.129Zm-24.889-21.334h20.466l21.333-21.333h-9.799c-5.888 0-10.667-4.779-10.667-10.667v-9.799l-21.333 21.333v20.466Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.54 375.762c-78.421 0-142.222-63.801-142.222-142.222S99.119 91.318 177.54 91.318s142.222 63.801 142.222 142.222c0 13.767-1.963 27.378-5.845 40.462l-20.452-6.058c3.3-11.122 4.964-22.699 4.964-34.404 0-66.659-54.23-120.889-120.889-120.889-66.66 0-120.889 54.23-120.889 120.889 0 66.66 54.229 120.889 120.889 120.889 47.175 0 90.354-27.733 109.98-70.642l19.399 8.875c-23.096 50.489-73.884 83.1-129.379 83.1Z",
    style: {
      fillRule: "nonzero"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m287.52 283.787 5.945-15.843 20.452 6.058-6.998 18.66-19.399-8.875Z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M177.54 325.985c-50.973 0-92.445-41.472-92.445-92.445 0-50.972 41.472-92.444 92.445-92.444 50.972 0 92.444 41.472 92.444 92.444 0 50.973-41.472 92.445-92.444 92.445Zm0-163.556c-39.211 0-71.111 31.9-71.111 71.111 0 39.211 31.9 71.111 71.111 71.111 39.211 0 71.111-31.9 71.111-71.111 0-39.211-31.9-71.111-71.111-71.111Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.54 276.207c-23.524 0-42.667-19.143-42.667-42.667 0-23.523 19.143-42.667 42.667-42.667 23.523 0 42.667 19.144 42.667 42.667 0 23.524-19.144 42.667-42.667 42.667Zm0-64c-11.762 0-21.333 9.571-21.333 21.333 0 11.762 9.571 21.333 21.333 21.333 11.762 0 21.333-9.571 21.333-21.333 0-11.762-9.571-21.333-21.333-21.333Z",
    style: {
      fillRule: "nonzero"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M177.54 244.207a10.582 10.582 0 0 1-7.538-3.129c-4.167-4.167-4.167-10.923 0-15.09l106.667-106.667c4.167-4.167 10.922-4.167 15.09 0 4.167 4.168 4.167 10.923 0 15.09L185.092 241.078a10.638 10.638 0 0 1-7.552 3.129Z",
    style: {
      fillRule: "nonzero"
    }
  }));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPassion);
export default __webpack_public_path__ + "static/media/passion.a8500207f79b34808133dcf098ac38d7.svg";
export { ForwardRef as ReactComponent };